<script>
export default {
  props: {
    title: {
      type: String,
      default: undefined
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    formattedValue() {
      return this.value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  },

  render() {
    return (
      <li class={this.$style.root}>
        <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
          <el-col sm={16}>
            {this.$scopedSlots.title ? (
              this.$scopedSlots.title(this.title)
            ) : (
              <div class={this.$style.title}>{this.title}</div>
            )}
            {this.$scopedSlots.description ? (
              this.$scopedSlots.description(this.description)
            ) : (
              <div class={this.$style.description}>{this.$slots.default}</div>
            )}
          </el-col>
          <el-col sm={8} class={this.$style.valueContainer}>
            {this.$scopedSlots.value ? (
              this.$scopedSlots.value(this.formattedValue)
            ) : (
              <div class={this.$style.value}>{this.formattedValue}</div>
            )}
          </el-col>
        </el-row>
      </li>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  margin-bottom: 1rem;
}

.title {
  font-size: 1.25rem;
  font-weight: bold;
}

.description {
  margin-top: 0.25rem;
  color: $--color-text-secondary;
}

.valueContainer {
  text-align: right;
}

.value {
  font-size: 1.25rem;
  font-weight: bold;
}
</style>
